import React from 'react';

import { Formik, Field } from 'formik';

import TableFilterModal from 'CommonComponents/TableFilterModal';

export default function ActionSummaryFilters(props) {
    return (
        <TableFilterModal noActions>
            <Formik
                enableReinitialize
                initialValues={{
                    owner: '',
                    status_id: '',
                    priority: '',
                }}
                onSubmit={(values, actions) => props.onSubmit(values)}
                onReset={() => props.onReset()}
            >
                {({ handleSubmit, handleReset }) => (
                    <div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <Field type="text" className="text-input" name="owner" placeholder={$t('Owner')} />
                            <label className="tw-flex tw-flex-col">
                                <div className="select-label">{$t('Status')}:</div>
                                <Field as="select" className="select-input" name="status_id">
                                    <option value="">{$t('Status')}</option>
                                    {props.datasets?.actionSummaryStatuses?.map(({ id, title }) => (
                                        <option key={id} value={id}>
                                            {title}
                                        </option>
                                    ))}
                                </Field>
                            </label>
                            <label className="tw-flex tw-flex-col">
                                <div className="select-label">{$t('Priority')}:</div>
                                <Field as="select" className="select-input" name="priority">
                                    <option value="">{$t('Priority')}</option>
                                    {props.datasets?.actionSummaryPriorities?.map((priority) => (
                                        <option key={priority} value={priority}>
                                            {priority}
                                        </option>
                                    ))}
                                </Field>
                            </label>
                        </div>
                        <div className="tw-flex tw-justify-end tw-gap-x-2 tw-pt-3">
                            <button className="table__filter-modal__apply-btn !tw-bg-red" type="button" onClick={handleReset}>
                                {$t('Reset all')}
                            </button>
                            <button className="table__filter-modal__apply-btn" type="button" onClick={handleSubmit}>
                                {$t('Apply filters')}
                            </button>
                        </div>
                    </div>
                )}
            </Formik>
        </TableFilterModal>
    );
}
